import { Dispatch, FunctionComponent, SetStateAction, useCallback } from "react";
import { useTranslation } from "react-i18next";

import { useNavigate } from "react-router-dom";

import { Modal } from "@/components";

import { FlagHeader } from "@/components/Modals/FlagHeader";
import { ROUTE_CONFIG } from "@/routes/config";
import { authSelector } from "@/pages/Public/redux/auth.slice";
import { useAppSelector } from "@/redux/hooks";

interface SelectCreatingCourseFlowModalProps {
	isOpen: boolean;
	setIsOpen: Dispatch<SetStateAction<boolean>>;
}
const { COURSES } = ROUTE_CONFIG;

export const SelectCreatingCourseFlowModal: FunctionComponent<
	SelectCreatingCourseFlowModalProps
> = ({ isOpen, setIsOpen }) => {
	const { t } = useTranslation();
	const { user } = useAppSelector(authSelector);
	const ts = (key: string) => t(`courses.create.${key}`);
	const navigate = useNavigate();

	const handleSubmit = useCallback(() => {
		const isUserCompanyActivated = user?.company?.activated;

		if (!isUserCompanyActivated) {
			navigate(`${COURSES}/create`);

			return;
		}

		navigate(`${COURSES}/generate`);
		setIsOpen(false);
	}, [navigate, setIsOpen, user]);

	const handleManual = useCallback(() => {
		navigate(`${COURSES}/create`);

		setIsOpen(false);
	}, [navigate, setIsOpen]);

	const handleClose = useCallback(() => {
		setIsOpen(false);
	}, [setIsOpen]);

	return (
		<Modal
			aboveHeader={<FlagHeader />}
			handleClose={handleClose}
			handleSave={handleSubmit}
			handleSecondSave={handleManual}
			isCloseShowing={true}
			isOpened={isOpen}
			secondSubmitButtonText={ts("manual-creation")}
			submitButtonText={ts("generative-ai")}
			title={ts("choose-creation-flow")}
		>
			<div className="whitespace-pre-line">{ts("creation-description")}</div>
		</Modal>
	);
};
